import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { GLOW_TYPE } from '../../../../Preview/PreviewDisplayConstants';

const glowTypesOptions = [
    { value: GLOW_TYPE.OUTER, text: 'Outer' },
    { value: GLOW_TYPE.INNER, text: 'Inner' },
];

const VisualizerLogoGlowTypeListItem = (props) => {
    const { logoGlowType, updateVisualizerSettings } = props;

    const onGlowTypeChange = (value) => {
        updateVisualizerSettings({
            logoGlowSettings: { glowType: value }
        });
    };

    return (
        <ToggleButtonListItem
            text='Type'
            value={logoGlowType}
            onChange={onGlowTypeChange}
            options={glowTypesOptions}
            toolTip={
                <>
                    <p>OUTER: The glow radiates around the outside of the logo.</p>
                    <p>INNER: Only the soft glow is shown, making the logo appear to glow from within.</p>
                </>
            }
        />
    );
};

const mapStateToProps = (state) => {
    const logoGlowSettings = state.createPreview.present.videoSettings.visualizer.logoGlowSettings || {};
    return { logoGlowType: logoGlowSettings.glowType ?? GLOW_TYPE.INNER };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerLogoGlowTypeListItem);
